import { Injectable } from '@angular/core';
import { CdcJsService } from '@spartacus/cdc/root';
import { of } from 'rxjs';

@Injectable()
export class CustomCdcJsService extends CdcJsService {
  override updateAddressWithoutScreenSet(formattedAddress: string, zipCode?: string, city?: string, country?: string) {
    console.log('CDC address update suppressed');
    // Return the expected format instead of null
    return of({ status: 'suppressed' });
  }
}
